export enum TaskType {
    Empty = 'empty',
    MemberDetails = 'memberdetails',
    CustomerDetails = 'customerdetails',
    ConnectWiseInfo = 'connectwiseinfo'
}
